import { render, staticRenderFns } from "./KonfigNotenuebersichtModal.vue?vue&type=template&id=b1b48ac4"
import script from "./KonfigNotenuebersichtModal.vue?vue&type=script&lang=js"
export * from "./KonfigNotenuebersichtModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports